module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chat"
  }, [_c('ChatMessages', {
    staticClass: "chat_messages",
    attrs: {
      "messages": _vm.messages
    }
  }), _c('ChatForm', {
    staticClass: "chat_form",
    on: {
      "submit": _vm.onSubmit
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-295e105a"}!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/index.vue
// module id = 97
// module chunks = 1